import React from 'react';
import SmiWidget from "../SmiWidget"

export const Feed = ({isDesktop, isFull}) => {

    const feedFullPc = <div>
        <SmiWidget blockId={'30223'}/>
    </div>

    const feedFullMobile = <div>
        <SmiWidget blockId={'30229'}/>
        <SmiWidget blockId={'30230'}/>
    </div>

    const feedPrvPc = <div>
        <SmiWidget blockId={'30173'}/>
        <SmiWidget blockId={'30174'}/>
        <SmiWidget blockId={'30175'}/>
    </div>

    const feedPrvMob = <div>
        <SmiWidget blockId={'30187'}/>
        <SmiWidget blockId={'30188'}/>
    </div>

    return (
        isFull ? (isDesktop ? feedFullPc : feedFullMobile) : (isDesktop ? feedPrvPc : feedPrvMob)
    );
}
